import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import ReactGA from 'react-ga4';

import theme from './theme';
import NavBar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Blogs from './pages/Blogs';
import Skills from './pages/Skills/Skills';
import About from './pages/About/About';
import ChatBox from './components/ChatBox/ChatBox';
import CookieBanner from './components/CookieBanner/CookieBanner';

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!process.env.REACT_APP_TRACKING_ID) return;
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
  return null;
}

if (process.env.REACT_APP_TRACKING_ID) {
  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Router>
          <AnalyticsTracker />
          <NavBar />
          <Box component="main" sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/about" element={<About />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Box>
          <Footer />
          <ChatBox />
          {/* <CookieBanner /> */}
        </Router>
      </Box>
    </ThemeProvider>
  );
}




